import { useAuth } from '@/contexts/auth-context';
import { useEffect, useRef } from 'react';

export class BillingTargetChangedError extends Error {}

/** Request identity, including the actor, never a cached billing permission. */
export function useBillingActionScope() {
  const { user } = useAuth();
  const scope = {
    organizationId: user?.currentBrand?.organizationId ?? null,
    brandId: user?.currentBrandId ?? null,
    userId: user?.id ?? null,
  };
  const current = useRef(scope);
  current.current = scope;
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const assertCurrent = (target: typeof scope) => {
    if (
      !mounted.current ||
      target.organizationId !== current.current.organizationId ||
      target.brandId !== current.current.brandId ||
      target.userId !== current.current.userId
    ) {
      throw new BillingTargetChangedError('Billing target changed');
    }
  };
  return { scope, assertCurrent };
}
